<div class="service-details-widget">
    <h3 class="title">{{productContent.productTitle}}</h3>

    <div class="service-details-categories">
        <ul *ngFor="let product of products">
            <li><a replaceUrl="true" [routerLink]="productsRoutes[product.sku]"
                    [queryParams]="{product: product.sku}">{{product.productName}}</a></li>
        </ul>
    </div>
</div>